import { render, staticRenderFns } from "./panel-left.vue?vue&type=template&id=4c8ab758&"
import script from "./panel-left.vue?vue&type=script&lang=js&"
export * from "./panel-left.vue?vue&type=script&lang=js&"
import style0 from "./panel-left.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports